export async function safeParseJson<T>(response: Response): Promise<T> {
    try {
        return await response.json() as T;
    } catch (error) {
        throw new Error('Failed to parse JSON response');
    }
}

export function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function validateRequiredParams<T extends object>(
    params: T,
    requiredParams: (keyof T)[]
): void {
    const missingParams = requiredParams.filter(param => !params[param]);

    if (missingParams.length > 0) {
        throw new Error(`Missing required parameters: ${missingParams.join(', ')}`);
    }
}